module.exports = __webpack_public_path__ + "img/pickUpBar.433763b9.svg";